// LinkBehavior.tsx
import React from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router"; // Make sure you're using react-router-dom

const LinkBehavior = React.forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }
>((props, ref) => {
  const { href, ...other } = props;
  // Map href to the to prop for react-router
  return <RouterLink ref={ref} to={href} {...other} />;
});

export default LinkBehavior;
